import { Box } from '@mui/material';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import ErrorScreen from '../ErrorScreen';

import { LoadingState, SilentLoadingState } from './ScreenStates';
import { fillColumnSx } from './screenLayout';
import { StateArea } from './StateArea';

const regionSx = [fillColumnSx, { minWidth: 0 }] as const;

const RegionLoading: React.FC<{ readonly label?: string }> = ({ label }) => {
  const { t, ready } = useTranslation(undefined, { useSuspense: false });
  if (label !== undefined) return <LoadingState label={label} />;
  if (!ready) return <SilentLoadingState />;
  return <LoadingState label={t('common.loading', 'Loading...')} />;
};

const RegionFailed: React.FC = () => (
  <StateArea>
    <ErrorScreen />
  </StateArea>
);

export interface PageRegionProps {
  readonly loadingLabel?: string;
  readonly children: React.ReactNode;
}

export const PageRegion: React.FC<PageRegionProps> = ({ loadingLabel, children }) => (
  <Box sx={regionSx}>
    <ErrorBoundary FallbackComponent={RegionFailed}>
      <Suspense fallback={<RegionLoading label={loadingLabel} />}>{children}</Suspense>
    </ErrorBoundary>
  </Box>
);
